import React, { Component, useState, useEffect, useRef } from "react";
import { Link, Router, useParams } from "react-router-dom";
import {
  Row,
  Col,
  Container,
  Button,
  ModalHeader,
  ModalFooter,
  Modal,
  ModalBody,
} from "reactstrap";
import Sidebar from "../../component/Sidebar";
import Header from "../../component/Header";
import right from "../../images/right.png";
import { API_URL } from "../../../config";
import backIcon from "../../images/back.png";
import md5 from "md5";

const Clientinformation = () => {
  const accessToken = localStorage.getItem("accessToken");
  const user_type = localStorage.getItem("userType");
  const selectedTrainer = localStorage.getItem("selectedTrainer");
  const userId = localStorage.getItem("user_id");
  const firstname = useRef();
  const allowclientviewdata = useRef();
  const lastname = useRef();
  const gender = useRef();
  const age = useRef();
  const education = useRef();
  const educationObj = useRef();
  const trainerSelected = useRef();
  const profession = useRef();
  const telephone = useRef();
  const email = useRef();
  const complaint = useRef();
  const address = useRef();
  const address2 = useRef();
  const city = useRef();
  const password = useRef();
  const zipcode = useRef();
  const state = useRef();
  const country = useRef();
  const [successModal, setsuccessModal] = useState(false);
  const successToggleModal = () => setsuccessModal(!successModal);
  const [client, setclient] = useState({});
  const [countries, setCountries] = useState([]);
  const [trainers, settrainers] = useState([]);
  const [states, setStates] = useState([]);
  let _userId = localStorage.getItem("user_id");
  let _userType = 3;
  let _trainer = false;
  const [Loader, setLoader] = useState(false);
  const [fillallfieldmodal, setFillallfieldModal] = useState(false);
  const fillallfieldtoggleModal = () =>
    setFillallfieldModal(!fillallfieldmodal);
  const [emailalreadyExitmodal, setEmailalreadyExitmodal] = useState(false);
  const EmailalreadyExittoggleModal = () =>
    setEmailalreadyExitmodal(!emailalreadyExitmodal);
  const [error, setError] = useState(false);
  const [loaderModal, setLoaderModal] = useState(false);
  const loaderToggleModal = () => setLoaderModal(!loaderModal);
  const [passwordShown, setPasswordShown] = useState(false);
  const { id } = useParams();

  const togglePasswordVisiblity = () => {
    setPasswordShown(passwordShown ? false : true);
  };

  useEffect(() => {
    getClient();
    getTrainers();
    getCountry();
  }, []);

  const getClient = () => {
    fetch(API_URL + "/client/profile/" + id, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        "x-access-token": accessToken,
      },
    }).then((response) => {
      if (response.status == 200) {
        response.json().then((resp) => {
          console.log("result", resp);
          setclient(resp.client[0]);
          getState(resp.client[0].country);
        });
      } else if (response.status == 401) {
        logout();
      } else {
        console.log("network error");
      }
    });
  };

  const getTrainers = () => {
    let url = API_URL + "/trainers?user_id=" + userId + "&status=1";

    fetch(url, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        "x-access-token": accessToken,
      },
    })
      .then((response) => {
        if (response.status == 200) {
          response.json().then((result) => {
            // console.log(result.trainers)
            if (result.status) {
              settrainers(result.trainers);
              // getClients();
            } else {
              alert("no data error");
            }
          });
        } else if (response.status == 401) {
          logout();
        } else {
          console.log("network error");
        }
      })
      .catch((err) => {
        // // console.log(err)
      });
  };

  const updateSelectTrainer = () => {
    localStorage.setItem("selectedTrainer", trainerSelected.current.value);
    localStorage.setItem("selectedClient", null);

    getClient();
  };

  function saveClientinfo() {
    setLoader(true);
    let data = {};

    data["firstname"] = firstname.current.value;
    data["user_type"] = 3;
    data["lastname"] = lastname.current.value;
    data["gender"] = gender.current.value;
    data["age"] = age.current.value;
    data["education"] = education.current.value;
    data["profession"] = profession.current.value;
    data["telephone"] = telephone.current.value;
    data["email"] = email.current.value;
    data["complaint"] = complaint.current.value;
    data["address"] = address.current.value;
    data["address2"] = address2.current.value;
    data["city"] = city.current.value;
    data["zipcode"] = zipcode.current.value;
    data["state"] = state.current.value;
    data["country"] = country.current.value;
    data["password"] = password.current.value;
    // data["AllowClientView"] = allowclientviewdata.current.value;

    if (
      firstname.current.value == "" ||
      lastname.current.value == "" ||
      age.current.value == "" ||
      education.current.value == "" ||
      profession.current.value == "" ||
      telephone.current.value == "" ||
      email.current.value == "" ||
      complaint.current.value == "" ||
      address.current.value == "" ||
      zipcode.current.value == "" ||
      state.current.value == "" ||
      country.current.value == ""
    ) {
      fillallfieldtoggleModal();

      return false;
    } else {
      setLoaderModal(true);
    }

    fetch(API_URL + "/app/update/profile/" + md5(id), {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "x-access-token": accessToken,
      },
      body: JSON.stringify(data),
    }).then((response) => {
      if (response.status == 200) {
        response.json().then((resp) => {
          // console.log("results", resp);
          successToggleModal();
          setLoaderModal(false);
        });
      } else if (response.status == 200) {
        response.json().then((resp) => {
          setLoaderModal(false);
          if (resp.code == -3) {
            EmailalreadyExittoggleModal();
          }
        });
      } else if (response.status == 400) {
        setLoaderModal(false);
        EmailalreadyExittoggleModal();
      } else if (response.status == 401) {
        logout();
      } else {
        console.log("network error");
      }
    });
  }

  function isValidEmail(email) {
    return /\S+@\S+\.\S+/.test(email);
  }

  const handleEmail = () => {
    if (!isValidEmail(email.current.value)) {
      setError(true);
    } else {
      setError(false);
    }
  };

  const getCountry = () => {
    fetch(API_URL + "/countries", {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        "x-access-token": accessToken,
      },
    }).then((response) => {
      if (response.status == 200) {
        response.json().then((resp) => {
          // console.log("result", resp);
          setCountries(resp.countries);
        });
      } else if (response.status == 401) {
        logout();
      } else {
        console.log("network error");
      }
    });
  };
  const getState = (countryid) => {
    fetch(API_URL + "/states?country_id=" + countryid, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        "x-access-token": accessToken,
      },
    }).then((response) => {
      if (response.status == 200) {
        response.json().then((resp) => {
          // console.log("result", resp);
          setStates(resp.states);
        });
      } else if (response.status == 401) {
        logout();
      } else {
        console.log("network error");
      }
    });
  };
  const logout = () => {
    localStorage.clear();
    window.location.reload();
  };

  const handleCountryUpdate = () => {
    getState(country.current.value);
  };

  const handleKeyPress = (event) => {
    // Prevent the user from typing alphabetic characters
    const key = event.key;
    const regex = /^[0-9-.()+]$/;
    if (!regex.test(key)) {
      event.preventDefault();
    }
  };

  return (
    <div className="demodata-bg">
      <Header />
      <div className="wrp-dashbord">
        <div className="sidebar-section">
          <Sidebar />
        </div>
        <div className="right-section">
          <div className="client-info-c">
            <div className="back-icon-wrp">
              <Link to="/list/client" className="backbtn-icon">
                <img src={backIcon} alt="backicon" />
                <span>Back</span>
              </Link>
            </div>
            <h3>Client Information</h3>
          </div>
          <div className="client-info-box">
            <div className="row">
              <div className="col-lg-6">
                <div className="client-input">
                  <p>First Name *</p>
                  <input
                    placeholder="Enter first name"
                    defaultValue={client.firstname}
                    ref={firstname}
                  />
                </div>
              </div>
              <div className="col-lg-6">
                <div className="client-input">
                  <p>Last Name *</p>
                  <input
                    placeholder="Enter last name"
                    defaultValue={client.lastname}
                    ref={lastname}
                  />
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-lg-3">
                <div className="client-input">
                  <p>Gender *</p>
                  <select defaultValue={client.gender} ref={gender}>
                    <option
                      value="1"
                      selected={client.gender == "1" ? true : false}
                    >
                      Male
                    </option>
                    <option
                      value="2"
                      selected={client.gender == "2" ? true : false}
                    >
                      Female
                    </option>
                    <option
                      value="3"
                      selected={client.gender == "3" ? true : false}
                    >
                      Other
                    </option>
                  </select>
                </div>
              </div>
              <div className="col-lg-3">
                <div className="client-input">
                  <p>Age *</p>
                  <input
                    placeholder="Enter age"
                    defaultValue={client.age}
                    ref={age}
                  />
                </div>
              </div>
              <div className="col-lg-6">
                <div className="client-input">
                  <p>Education *</p>
                  <input
                    placeholder="Education"
                    defaultValue={client.education}
                    ref={education}
                  />
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-lg-6">
                <div className="client-input">
                  <p>Profession *</p>
                  <input
                    placeholder="Enter profession"
                    defaultValue={client.profession}
                    ref={profession}
                  />
                </div>
              </div>
              <div className="col-lg-6">
                <div className="client-input">
                  <p>Telephone *</p>
                  <input
                    type="text"
                    placeholder="Enter a telephone"
                    onKeyPress={handleKeyPress}
                    defaultValue={client.telephone}
                    ref={telephone}
                  />
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-lg-6">
                <div className="client-input">
                  <p>Email *</p>
                  <input
                    placeholder="Enter an email"
                    onChange={handleEmail}
                    defaultValue={client.email}
                    ref={email}
                  />
                  {error && <p className="validemail">invalid Email</p>}
                </div>
              </div>
              <div className="col-lg-6">
                <div className="client-input">
                  <p>Password *</p>
                  <input
                    type={passwordShown ? "text" : "password"}
                    placeholder="Enter Password"
                    defaultValue={client.password}
                    ref={password}
                  />
                  {passwordShown ? (
                    <i
                      class="fa fa-eye-slash pass-eye2"
                      aria-hidden="true"
                      onClick={togglePasswordVisiblity}
                    ></i>
                  ) : (
                    <i
                      className="fa fa-eye pass-eye2"
                      aria-hidden="true"
                      onClick={togglePasswordVisiblity}
                    ></i>
                  )}
                </div>
              </div>
            </div>
            <div className="row">
              <div
                className={
                  user_type == 1 || user_type == 2 || user_type == 7
                    ? "col-lg-6"
                    : "col-lg-12"
                }
              >
                <div className="client-input">
                  <p>Educational Objective *</p>
                  <textarea
                    className="complainttextarea"
                    placeholder="Enter a present considiton"
                    defaultValue={client.complaint}
                    ref={complaint}
                  ></textarea>
                </div>
              </div>
              {(user_type == 1 || user_type == 2 || user_type == 7) && (
                <div className="col-lg-6">
                  <div className="client-input">
                    <p>Allow Client to view and download data ?</p>
                    <select
                      className="allowclientinput"
                      ref={allowclientviewdata}
                    >
                      <option
                        value="1"
                        selected={client.AllowClientView == 1 ? true : false}
                      >
                        Yes
                      </option>
                      <option
                        value="0"
                        selected={client.AllowClientView == 0 ? true : false}
                      >
                        No
                      </option>
                    </select>
                  </div>
                </div>
              )}
            </div>
            <div className="row">
              {/* <div className="col-lg-6">
                <div className="client-input">
                  <p>Educational Objective *</p>
                  <input
                    placeholder="Enter Educational Objective"
                    defaultValue={""}
                    ref={educationObj}
                  />
                </div>
              </div> */}
              <div className="col-lg-6">
                <div className="client-input">
                  <p>Trainer *</p>
                  <select
                    name="trainer"
                    onChange={updateSelectTrainer}
                    ref={trainerSelected}
                  >
                    <option value="">Choose Trainer</option>
                    <option className="selected-bold" value={"all"}>
                      All trainers
                    </option>
                    {trainers.map((items, i) => {
                      return (
                        <option
                          className="selected-bold"
                          selected={items.id == selectedTrainer ? true : false}
                          value={items.id}
                        >
                          {items.firstname} {items.lastname}
                        </option>
                      );
                    })}
                  </select>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-lg-12">
                <div className="client-input">
                  <p>Address 1 *</p>
                  <textarea
                    name="address"
                    placeholder="Enter physical adderss 1"
                    defaultValue={client.address}
                    ref={address}
                  ></textarea>
                </div>
              </div>
              <div className="col-lg-12">
                <div className="client-input">
                  <p>Address 2</p>
                  <textarea
                    name="address2"
                    placeholder="Enter physical adderss 2"
                    defaultValue={client.address2}
                    ref={address2}
                  ></textarea>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-lg-3">
                <div className="client-input">
                  <p>Country *</p>
                  <select
                    name="country"
                    onChange={handleCountryUpdate}
                    ref={country}
                  >
                    <option value="">Choose Country</option>
                    {countries.map((countries, i) => {
                      return (
                        <option
                          selected={
                            client.country == countries.id ? true : false
                          }
                          value={countries.id}
                        >
                          {countries.name}
                        </option>
                      );
                    })}
                  </select>
                </div>
              </div>
              <div className="col-lg-3">
                <div className="client-input">
                  <p>State/Province *</p>
                  <select name="state" id="state" ref={state}>
                    <option>Choose States/Province</option>

                    {states.map((states, i) => {
                      return (
                        <option
                          selected={states.id == client.state ? true : false}
                          value={states.id}
                        >
                          {states.name}
                        </option>
                      );
                    })}
                  </select>
                </div>
              </div>
              <div className="col-lg-3">
                <div className="client-input">
                  <p>City *</p>
                  <input
                    placeholder="Enter City"
                    defaultValue={client.city}
                    ref={city}
                  />
                </div>
              </div>
              <div className="col-lg-3">
                <div className="client-input">
                  <p>Postal Code *</p>
                  <input
                    placeholder="Enter postal code"
                    defaultValue={client.zipcode}
                    ref={zipcode}
                  />
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-lg-6">
                <div className="go-back">
                  <Link to="/viewcreate">Go Back</Link>
                </div>
              </div>
              <div className="col-lg-6">
                <Modal
                  isOpen={successModal}
                  toggle={successToggleModal}
                  className="connect-box"
                  centered={true}
                >
                  <ModalHeader toggle={successToggleModal}>
                    <span className="ml-1 roititle font-weight-bold">
                      Successfull
                    </span>
                  </ModalHeader>
                  <ModalBody>
                    <div className="modal-p">
                      <div className="right-circle">
                        <img src={right} />
                      </div>
                      <h4>Saved!</h4>
                      <p>
                        Client profile information has been updated successfully
                      </p>
                    </div>
                  </ModalBody>
                </Modal>
                <div className="create-btn">
                  <button type="submit" onClick={saveClientinfo}>
                    Update
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Modal
        isOpen={fillallfieldmodal}
        toggle={fillallfieldtoggleModal}
        className="connect-box"
        centered={true}
      >
        <ModalHeader toggle={fillallfieldtoggleModal}>
          <span className="ml-1 roititle font-weight-bold">Error</span>
        </ModalHeader>
        <ModalBody>
          <div className="modal-error-p">
            <p>Please fill all field</p>
          </div>
        </ModalBody>
      </Modal>

      <Modal
        isOpen={emailalreadyExitmodal}
        toggle={EmailalreadyExittoggleModal}
        className="connect-box"
        centered={true}
      >
        <ModalHeader toggle={EmailalreadyExittoggleModal}>
          <span className="ml-1 roititle font-weight-bold">Error</span>
        </ModalHeader>
        <ModalBody>
          <div className="modal-error-p">
            <p>Account already exist with this email</p>
          </div>
        </ModalBody>
      </Modal>

      <Modal
        isOpen={loaderModal}
        toggle={loaderToggleModal}
        className="connect-box"
        centered={true}
      >
        <ModalHeader toggle={loaderToggleModal}>
          <span className="ml-1 roititle modal-head">
            Request processing...
          </span>
        </ModalHeader>
        <ModalBody>
          <p className="text-center">Please wait...</p>
          <div className="wrp-chart-loader">
            <div class="loading">
              <div class="loading-1"></div>
              <div class="loading-2"></div>
              <div class="loading-3"></div>
              <div class="loading-4"></div>
            </div>
          </div>
        </ModalBody>
      </Modal>
    </div>
  );
};

export default Clientinformation;
